import { Model } from 'backbone';

export default class Tipping extends Model {

	initialize() {
		this.prefix = 'tipping/';

		this.setGameBarUrl();
	}

	setGameBarUrl() {
		this.url = 'snapshot';

		return this;
	}
}